import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const PostView = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [post, setPost] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const res = await fetch(`https://api.dikshasea.in/api/posts/${id}`);
        if (!res.ok) throw new Error('Post not found');
        const data = await res.json();
        setPost(data);
      } catch (err) {
        setError(err.message);
      }
    };

    fetchPost();
  }, [id]);

  const formatDate = (dateStr) => {
    return new Date(dateStr).toLocaleString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  if (error) return <div className="alert alert-danger text-center mt-5">❌ {error}</div>;
  if (!post) return <div className="text-center mt-5">⏳ Loading post...</div>;

  const tags = (post.tags || '').split(',').map(tag => tag.trim()).filter(tag => tag.length > 0);

  return (
    <div style={styles.wrapper}>
      <div className="container">
        {/* <button className="btn btn-outline-secondary mb-4" onClick={() => navigate(-1)}>
          ← Back to Blog
        </button> */}

        <div style={styles.card}>
          <h1 className="mb-3" style={styles.title}>{post.title}</h1>

          <p className="text-muted mb-3" style={styles.meta}>
            <i className="fas fa-user"></i> {post.author_name} &nbsp; | &nbsp;
            <i className="fas fa-clock"></i> {formatDate(post.created_at)}
          </p>

          {post.image_url && (
            <div className="my-3">
              <img
                src={post.image_url}
                alt="Post Visual"
                className="img-fluid rounded"
                style={styles.image}
              />
            </div>
          )}

          <div
            className="post-body"
            dangerouslySetInnerHTML={{ __html: post.content }}
            style={styles.content}
          ></div>

          {tags.length > 0 && (
            <div className="mt-4">
              <strong style={styles.tagLabel}>Tags:</strong>{' '}
              {tags.map((tag, index) => (
                <span key={index} className="badge bg-primary me-2">
                  #{tag}
                </span>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const styles = {
  wrapper: {
    padding: '50px 0',
    backgroundColor: '#f9fafb',
    minHeight: '100vh',
    marginTop: '4rem',
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
  },
  card: {
    // background: '#fff',
    padding: '30px',
    borderRadius: '12px',
    // boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
  },
  title: {
    fontSize: '2rem',
    fontWeight: '600',
    color: '#1f2937',
  },
  meta: {
    fontSize: '14px',
    color: '#6c757d',
  },
  image: {
    width: '100%',
    maxHeight: '400px',
    objectFit: 'cover',
    borderRadius: '8px',
  },
  content: {
    marginTop: '20px',
    lineHeight: '1.8',
    fontSize: '16px',
    color: '#343a40',
  },
  tagLabel: {
    fontSize: '16px',
    color: '#333',
  },
};

export default PostView;
